import Actions from '../../redux/Actions';
import Config from '../../globals/Config';
import Store from '../../redux/Store';
import HttpService from '../HttpService/HttpService';
import Constants from '../../globals/Constants';
import {nullEntitlementStatusFactory} from '../../types/EntitlementStatusModel';
import * as moment from 'moment';
import GoogleAnalyticsService from '../GoogleAnalyticsService/GoogleAnalyticsService';
import EntitlementsValidator from '../EntitlementsValidator/EntitlementsValidator';
import AuthorizationsResponseModel from '../../types/AuthorizationsResponseModel';

const baseUrl = Config.entitlementsEndPointUrl + Config.entitlementsApiPrefix + '/entitlements';
const startTrialUrl = Config.apiEndPoint + Config.apiPrefix;

const getEntitlementStatus = async (userId: string): Promise<AuthorizationsResponseModel> => {
   try {
      const response = await HttpService.executeRequestWithErrorHandling(() => HttpService.getWithTscAuthToken(`${baseUrl}/${userId}/${Constants.entitlements.feedbackProduct}`), 'GetEntitlementStatus', Constants.statusCodes.ok);
      const entitlement = {
         level: response.data.level,
         status: response.data.status,
         expirationDate: response.data.expirationDate ? moment.utc(response.data.expirationDate) : null,
         expires: response.data.expires
      };

      Store.dispatch(Actions.setEntitlementStatus(entitlement));

      const authorizations: AuthorizationsResponseModel = entitlement.expires && EntitlementsValidator.isExpired(entitlement.expirationDate) ?
         {quotas: {Reviewers: 0, Reviews: 0}, actions: []} :
         {quotas: response.data.quotas, actions: [Constants.entitlements.permissions.createReview]};

      Store.dispatch(Actions.setAuthorization(authorizations));
      return authorizations;
   } catch (e) {
      Store.dispatch(Actions.setEntitlementStatus(nullEntitlementStatusFactory()));
      Store.dispatch(Actions.setAuthorization({quotas: {Reviews: 0, Reviewers: 0}, actions: [Constants.entitlements.permissions.startTrial]}));
   }
};

const startTrial = async (userId: string): Promise<void> => {
   await HttpService.executeRequestWithErrorHandling(() => HttpService.postWithTscAuthToken(`${startTrialUrl}/users/me/trial`), 'StartTrial', Constants.statusCodes.created);
   GoogleAnalyticsService.trackTrialStarted(userId);
};

const startTrialAndSave = async (userId: string): Promise<void> => {
   try {
      await startTrial(userId);
   } catch (e) {
      return;
   }

   await getEntitlementStatus(userId);
};

const startGracePeriod = async (userId: string, orderId: string): Promise<void> => {
   const gracePeriodInfo = {techSmithId: userId, product: Constants.entitlements.feedbackProduct, orderId: orderId};
   try {
      await HttpService.executeRequestWithErrorHandling(() => HttpService.postWithTscAuthToken(`${baseUrl}/grace`, gracePeriodInfo), 'StartGracePeriod', Constants.statusCodes.accepted);
      await getEntitlementStatus(userId);
   } catch (e) {
      if (e && e.status && e.status === Constants.statusCodes.conflict) {
         await getEntitlementStatus(userId);
         return;
      }
      throw e;
   }
};

export default {
   getEntitlementStatus,
   startTrial,
   startTrialAndSave,
   startGracePeriod
};
